import LAYOUT_TYPES from '../types/Layout'
import { makeActionCreator } from '../../modules/utilities/store'

const LayoutActions = {
  /**
   * @param appBarTitle {string}
   * @returns {{ type: string, data: { appBarTitle: string } }}
   */
  setAppBarTitle: makeActionCreator(LAYOUT_TYPES.SET_APPBAR_TITLE, 'appBarTitle'),
  /**
   * @param isLoading {boolean}
   * @param fetchId {string}
   * @returns {{ type: string, data: { isLoading: boolean, fetchId: string } }}
   */
  setIsLoading: makeActionCreator(LAYOUT_TYPES.SET_IS_LOADING, 'isLoading', 'fetchId'),
  /**
   * @param drawerMenuOpen {boolean}
   * @returns {{ type: string, data: { drawerMenuOpen: boolean } }}
   */
  setDrawerMenuOpen: makeActionCreator(LAYOUT_TYPES.SET_DRAWER_MENU_OPEN, 'drawerMenuOpen'),
  /**
   * @param chatDrawerOpen {boolean}
   * @returns {{ type: string, data: { chatDrawerOpen: boolean } }}
   */
  setChatDrawerOpen: makeActionCreator(LAYOUT_TYPES.SET_CHAT_DRAWER_OPEN, 'chatDrawerOpen'),
  /**
   * Open/close the chat drawer for a panel (main 1:1 chat vs group chat). Closes when the same panel is toggled again.
   * @param panel {'main'|'groups'}
   */
  toggleChatDrawer: makeActionCreator(LAYOUT_TYPES.TOGGLE_CHAT_DRAWER, 'panel'),
  /**
   * Open the main chat drawer and focus the Chats tab on a device conversation.
   * @param deviceId {string}
   */
  openMainChatForDevice: makeActionCreator(LAYOUT_TYPES.OPEN_MAIN_CHAT_FOR_DEVICE, 'deviceId'),
  clearMainChatDevice: makeActionCreator(LAYOUT_TYPES.CLEAR_MAIN_CHAT_DEVICE),
  /**
   * Open the chat drawer on the Chat groups tab and focus a group conversation.
   * @param chatGroupId {string}
   */
  openMainChatForChatGroup: makeActionCreator(LAYOUT_TYPES.OPEN_MAIN_CHAT_FOR_CHAT_GROUP, 'chatGroupId'),
  clearMainChatChatGroup: makeActionCreator(LAYOUT_TYPES.CLEAR_MAIN_CHAT_CHAT_GROUP),
  /**
   * @param framelessModeTurnedOn {boolean}
   * @returns {{ type: string, data: { framelessModeTurnedOn: boolean } }}
   */
  setFramelessModeTurnedOn: makeActionCreator(LAYOUT_TYPES.SET_FRAMELESS_MODE_TURNED_ON, 'framelessModeTurnedOn')
}

export default LayoutActions
